import React, { useLayoutEffect, useState, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { categoryService } from "../../../apis/apiServices/Category";
import { subCategoryService } from "../../../apis/apiServices/SubCategory";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";

export default function SubCategoryComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Sub Category ";
    getSubcategoryList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [AssetGroupList, setAssetGroupList] = useState([]);
  const [errors, setErrors] = useState({});
  const [AssetSubCategory, setAssetSubCategory] = useState([]);
  const refDataGrid = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeViewModal = () => {
    setIsModalOpen(false);
  };

  const [Subcategory, setSubcategory] = useState({
    id: 0,
    name: "",
    code: "",
    categoryId: 0,
    isRfId: false,
    isSizeEnable: false,
    isActive: true,
    rowData: null,
  });

  const getSubcategoryList = async () => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await subCategoryService.getSubCategoryList();
      setAssetSubCategory(response?.data);
      const categoryResponse = await categoryService.getCategoryList();
      setAssetGroupList(categoryResponse?.data);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  useEffect(() => {
    getSubcategoryList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!Subcategory.name) newErrors.name = "Please enter sub category name.";
    if (!Subcategory.categoryId)
      newErrors.categoryId = "Please select category.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      let body = {
        id: Subcategory.id,
        code: Subcategory?.code || "",
        name: Subcategory?.name || "",
        categoryId: Subcategory?.categoryId || 0,
        isRfId: Subcategory?.isRfId || false,
        isSizeApplicable: Subcategory?.isSizeEnable || false,
        isActive: Subcategory?.isActive || false,
        ModifiedBy: user?.userId,
      };

      const response = await subCategoryService.addSubCategory(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");

        setIsSubmitted(false);
        setErrors({});
        return;
      }
      getSubcategoryList();
      setIsSubmitted(false);

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/SubCategory", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    setSubcategory({
      id: 0,
      name: "",
      code: "",
      isRfId: false,
      isSizeEnable: false,
      isActive: true,
      rowData: null,
    });
  };

  const handleInputChange = (e, field) => {
    let err = { ...errors };
    if (field === "name") {
      err.name = "";
    }
    if (field === "categoryId") {
      err.categoryId = "";
    }
    if (field === "code") {
      err.code = "";
    }
    setErrors(err);
    setSubcategory((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderRfidCell = ({ value }) => {
    const isRfId = value === true;

    return (
      <div>
        <span />
        {isRfId ? "Yes" : "No"}
      </div>
    );
  };
  const renderSizeCell = ({ value }) => {
    const isSize = value === true;

    return (
      <div>
        <span />
        {isSize ? "Yes" : "No"}
      </div>
    );
  };
  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    setSubcategory({
      id: e.data.id,
      name: e.data.name,
      code: e.data.code,
      isActive: e.data.isActive,
      categoryId: e.data.categoryId,
      isRfId: e.data.isRfId,
      isSizeEnable: e.data.isSizeApplicable,
      rowData: e.data,
    });
    console.log(e);
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const onCellPrepared = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "#595959"; // #808080
      e.cellElement.style.color = "White";
    } else {
      e.cellElement.style.color = "#353839";
    }
  };
  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AssetSubCategory}
              ref={refDataGrid}
              showColumnLines={false}
              showRowLines={true}
              columnAutoWidth={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              // onCellPrepared={onCellPrepared}
              width={"100%"}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  },
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      text: "Refresh",
                      hint: "Refresh",
                      type: "default",
                      stylingMode: "outlined",
                      onClick: () => getSubcategoryList(),
                    },
                  }
                );
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width={60}
                caption={""}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* <Icon
                            className="iconify-size mr-2"
                            title="View"
                            tooltip="View"
                            icon="solar:document-text-outline"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsModalOpen(true)}
                          /> */}

                      <Icon
                        className="iconify-size mr-2"
                        title="Edit"
                        tooltip="Edit"
                        icon="solar:pen-line-duotone"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsCityModalOpen(true)}
                      />

                      <Icon
                        className="iconify-size"
                        title="Delete"
                        tooltip="Delete"
                        icon="fluent:delete-32-regular"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handledelete(e)}
                      />
                    </span>
                  );
                }}
              ></Column>

              <Column
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column dataField="code" caption="Code" allowFiltering={false} />
              <Column
                dataField="categoryName"
                caption="Category Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
                allowSearch={true}
              />
              <Column
                dataField="isRfId"
                caption="RFID Applicable"
                cellRender={renderRfidCell}
                alignment="left"
                allowSearch={true}
              />
              <Column
                dataField="isSizeApplicable"
                caption="Size Applicable"
                cellRender={renderSizeCell}
                alignment="left"
                allowSearch={true}
              />
              <Column
                dataField="categoryName"
                visible={false}
                caption="Group Name"
                allowFiltering={false}
                allowSearch={true}
              />

              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Sub Category" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal custom-modal-medium"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="SubCategory  Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">
              {Subcategory.id === 0
                ? `Add Sub Category`
                : `Update Sub Category [${Subcategory.name}] For Category [${Subcategory.rowData?.categoryName}]`}
            </div>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <label>Code </label>
              <TextBox
                className={`form-control ${errors.code ? "is-invalid" : ""}`}
                height={37}
                placeholder="Enter code"
                showClearButton={true}
                valueChangeEvent="keyup"
                value={Subcategory.code}
                onValueChanged={(e) => handleInputChange(e, "code")}
              />
              {errors.code && <div className="text-danger">{errors.code}</div>}
            </div>

            <div className="form-group">
              <label>
                Category <span className="text-danger">*</span>{" "}
              </label>
              <SelectBox
                dataSource={AssetGroupList}
                className="basic-multi-select"
                showClearButton={true}
                displayExpr="name" // adjust according to your object
                valueExpr="id"
                placeholder="Select state"
                value={Subcategory.categoryId}
                onValueChanged={(e) => handleInputChange(e, "categoryId")}
                // className={`form-control ${errors.stateId ? 'is-invalid' : ''}`}
              />
              {errors.categoryId && (
                <div className="text-danger">{errors.categoryId}</div>
              )}
            </div>

            <div className="form-group">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <TextBox
                className="form-control form-control-sm"
                height={37}
                placeholder="Enter sub category name"
                showClearButton={true}
                valueChangeEvent="keyup"
                value={Subcategory.name}
                onValueChanged={(e) => handleInputChange(e, "name")}
              />
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </div>

            <div className="form-group">
              <CheckBox
                text="RFID"
                value={Subcategory.isRfId}
                onValueChanged={(e) => handleInputChange(e, "isRfId")}
              />
            </div>
            <div className="form-group">
              <CheckBox
                text="Is Size Applicable"
                value={Subcategory.isSizeEnable}
                onValueChanged={(e) => handleInputChange(e, "isSizeEnable")}
              />
            </div>
            <div className="form-group">
              <CheckBox
                text="Is Active"
                value={Subcategory.isActive}
                onValueChanged={(e) => handleInputChange(e, "isActive")}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Asset Sub Group</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Code: </span> {Subcategory.code}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Name: </span> {Subcategory.name}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Asset Group: </span>{" "}
                    {
                      AssetGroupList.find(
                        (item) => item.id === Subcategory.groupId
                      )?.name
                    }
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Status: </span>{" "}
                    {Subcategory.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Close{" "}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
